<form [formGroup]="appForm" (ngSubmit)="onSubmit()" autocomplete="off">
  <div class="container" style="text-align:center">
    <div class="form-row">
      <div [className]="isSet?'col-md-1':'col-md-4'">
      </div>
      <div class="form-group col-md-4">
        <label class="col-form-label" for="appSelect">Application:</label>
        <select (change)="onAppChange($event)" id="appSelect" class="form-control" formControlName="ApplicationId">
          <option value='-1'>++ New Entry ++</option>
          <option *ngFor="let f of appList" [ngValue]="f.applicationId">{{f.appName}}</option>
        </select>
        <div *ngIf="ApplicationId.invalid && (ApplicationId.dirty || ApplicationId.touched)" class="alert alert-danger">
          <div *ngIf="ApplicationId.errors.required">
            Selection required.
          </div>
        </div>
      </div>

      <div class="form-group col-md-4" *ngIf="isSet">
        <label class="col-form-label" for="appName">Application Name:</label>
        <input id="appName" (blur)="onNameBlur($event)" type="text" class="form-control" formControlName="AppName" />
        <div *ngIf="AppName.invalid && (AppName.dirty || AppName.touched)" class="alert alert-danger">
          <div *ngIf="AppName.errors.required || AppName.errors.minlength || AppName.errors.maxlength">
            3-50 char required.
          </div>
        </div>
      </div>

      <div class="form-group col-md-2" *ngIf="isSet">
        <div class="form-row">
          <div class="form-group col-md-8">
            <label class="col-form-label" for="initials">Initials:</label>
            <input id="initials" maxlength="4" class="form-control" formControlName="Initials" />
            <div *ngIf="Initials.invalid && (Initials.dirty || Initials.touched)" class="alert alert-danger">
              <div *ngIf="Initials.errors.required || Initials.errors.minlength || Initials.errors.maxlength">
                2-4 char required.
              </div>
            </div>
          </div>
          <div class="form-group col-md-4">
            <label class="col-form-label" for="active">Active?</label>
            <input type="checkbox" class="form-control checkbox" formControlName="IsActive" id="active" />
          </div>
        </div>
      </div>
    </div>

    <div class="form-row" *ngIf="isSet">
      <!-- <div [className]="isSet?'col-md-2':'col-md-3'">
      </div> -->
      <div class="form-group col-md-12">
        <label class="col-form-label" for="primaryColor">Primary Color:</label>
        <input id="primaryColor" [value]="appForm.controls['PrimaryColor'].value"
          [style.background]="appForm.controls['PrimaryColor'].value" [cpOutputFormat]="'hex'"
          [cpAlphaChannel]="'always'" [colorPicker]="appForm.controls['PrimaryColor'].value"
          (colorPickerChange)="updatePrimaryColor($event)" formControlName="PrimaryColor" />
        <div *ngIf="PrimaryColor.invalid && (PrimaryColor.dirty || PrimaryColor.touched)" class="alert alert-danger">
          <div
            *ngIf="PrimaryColor.errors.required || PrimaryColor.errors.minlength || PrimaryColor.errors.maxlength || PrimaryColor.errors.pattern">
            Hex color Required.
          </div>
        </div>
      </div>
    </div>

    <div class="form-row" *ngIf="isSet">
      <!-- <div [className]="isSet?'col-md-2':'col-md-3'">
      </div> -->
      <div class="form-group col-md-12">
        <label class="col-form-label" for="secondaryColor">Secondary Color:</label>
        <input id="secondaryColor" [value]="appForm.controls['SecondaryColor'].value"
          [style.background]="appForm.controls['SecondaryColor'].value" [cpOutputFormat]="'hex'"
          [cpAlphaChannel]="'always'" [colorPicker]="appForm.controls['SecondaryColor'].value"
          (colorPickerChange)="updateSecondaryColor($event)" formControlName="SecondaryColor" />
        <div *ngIf="SecondaryColor.invalid && (SecondaryColor.dirty || SecondaryColor.touched)"
          class="alert alert-danger">
          <div
            *ngIf="SecondaryColor.errors.required || SecondaryColor.errors.minlength || SecondaryColor.errors.maxlength || SecondaryColor.errors.pattern">
            Hex color Required.
          </div>
        </div>
      </div>
    </div>
    <div id="application-dashboard">
      <div id="application-grid" class="dashboard">
        <div id="apps" class="card-deck justify-content-center no-gutters">
          <div class="col-lg-3 col-md-6" *ngIf="isSet">
            <div class="card application" [style]="'--iconp: ' + appForm.controls['PrimaryColor'].value + '; --icons: ' + appForm.controls['SecondaryColor'].value">
              <div class="card-img-top">
                <div [class]="appForm.controls['AppName'].value">
                  <p class="card-title">{{appForm.controls['AppName'].value}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <button *ngIf="isSet" class="btn btn-save" type="submit">Save Application</button>
    </div>
  </div>
</form>